import { createTheme } from "@mui/material/styles";

// 🎨 Configuração do tema global
const theme = createTheme({
  // 🌈 Paleta de cores personalizada
  palette: {
    mode: "dark", // Define o tema como escuro
    primary: { main: "#00d4ff" }, // Azul neon para destaques
    secondary: { main: "#ff4081" }, // Rosa para elementos secundários
    text: {
      primary: "#ffffff", // Cor principal do texto (branco)
      secondary: "#A0AEC0", // Cinza claro para textos secundários
    },
    background: {
      default: "#0d1b2a", // Fundo principal escuro
      paper: "#162238", // Fundo para cartões e painéis
    },
    success: { main: "#4caf50" }, // Verde para mensagens de sucesso
    error: { main: "#f44336" }, // Vermelho para erros
    warning: { main: "#ff9800" }, // Laranja para avisos
    info: { main: "#2196f3" }, // Azul para informações
  },

  // 📝 Tipografia - Definição global de fontes e tamanhos de texto
  typography: {
    fontFamily: "'Poppins', sans-serif", // Fonte global
    fontSize: 14, // Tamanho base da fonte
    h1: { fontSize: "2rem", fontWeight: 700 }, // Títulos grandes
    h2: { fontSize: "1.75rem", fontWeight: 600 }, // Subtítulos
    h3: { fontSize: "1.5rem", fontWeight: 500 },
    h4: { fontSize: "1.25rem", fontWeight: 500 },
    body1: { fontSize: "1rem" }, // Texto normal
    body2: { fontSize: "0.875rem" }, // Texto menor
  },

  // 🟦 Definição de bordas globais
  shape: {
    borderRadius: 4, // Bordas arredondadas para botões, caixas, etc.
  },

  // 🌟 Sombras personalizadas para profundidade
  shadows: [
    "none", // Índice 0
    "0px 4px 10px rgba(0, 212, 255, 0.1)", // Índice 1
    "0px 6px 15px rgba(0, 212, 255, 0.2)", // Índice 2
    ...Array(22).fill("0px 6px 15px rgba(0, 212, 255, 0.2)"), // Índices 3 a 24 (preenchendo com a sombra do índice 2)
  ],

  // 📏 Breakpoints personalizados para responsividade
  breakpoints: {
    values: {
      xs: 0, // Extra pequeno
      sm: 600, // Pequeno (tablets)
      md: 960, // Médio (notebooks)
      lg: 1280, // Grande (monitores maiores)
      xl: 1920, // Extra grande (telas 4K)
    },
  },

  // 🎨 Estilização Global de Componentes do Material UI
  components: {
    // 🔳 Estilos para o CssBaseline (reset de estilos)
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#0d1b2a", // Força o fundo escuro
          color: "#ffffff", // Garante que o texto seja branco
        },
      },
    },

    // 🔳 Estilos para TextFields (inputs)
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-input": { color: "white" }, // Texto dentro do input
          "& .MuiOutlinedInput-root": {
            "& fieldset": { borderColor: "rgba(255, 255, 255, 0.3)" }, // Borda inicial
            "&:hover fieldset": { borderColor: "#00d4ff" }, // Borda ao passar o mouse
            "&.Mui-focused fieldset": {
              borderColor: "#00d4ff",
              boxShadow: "0 0 10px rgba(0, 212, 255, 0.7)",
            }, // Borda quando o input está focado
          },
          "& .MuiInputLabel-root": {
            color: "#A0AEC0", // Cor do label inicial
            "&.Mui-focused": { color: "#00d4ff" }, // Cor do label quando focado
          },
        },
      },
    },

    // 🟦 Estilos para botões
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12, // Bordas arredondadas
          textTransform: "none", // Evita que o texto fique todo em maiúsculas
          fontWeight: "bold", // Texto mais forte
          transition: "all 0.3s ease", // Animação suave
          "&:hover": {
            transform: "scale(1.05)", // Efeito de leve crescimento ao passar o mouse
            boxShadow: "0 0 20px rgba(0, 212, 255, 0.4)", // Glow azul neon ao passar o mouse
          },
        },
      },
    },

    // 📝 Estilos para Paper (caixas e cartões)
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#162238", // Cor de fundo
          padding: "16px", // Espaçamento interno
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)", // Sombra sutil
          borderRadius: "12px", // Bordas arredondadas
        },
      },
    },

    // 📝 Estilos para Dialog (ajustando elevation)
    MuiDialog: {
      styleOverrides: {
        paper: {
          elevation: 16, // Reduzindo de 24 (padrão) para 16
        },
      },
    },
  },
});

export default theme;